import React from 'react';
import { useRouter } from 'next/router';

import Button from '@mui/material/Button';
import getCustomRadius from '~/src/lib/getCustomRadius';
import getCustomButton1 from '~/src/lib/getCustomButton1';
import { useSelector } from 'react-redux';
import translateMsg from '~/src/lib/translateMsg';
import { useScreenDetector } from '~/src/hooks/useScreenDetector';

function App(props) {
    const lang = useSelector((state) => state.lang);
    const business = useSelector((state) => state.business);

    const { isMobile, isTablet, isDesktop } = useScreenDetector();

    const router = useRouter();

    const url = '/account/orders/todayTableOrder';
    const url1 = '/account/orders/takeawayOrderNotDelivered';

    const nbTodayTableOrder = props.todayTableOrder.length;
    const nbTodayTakeawayOrder = props.takeawayOrder.length;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: 'center',
                width: '100%',
            }}
        >
            {nbTodayTableOrder > 0 && (
                <Button
                    variant="contained"
                    onClick={(event) => {
                        event.preventDefault();
                        router.push(url, url, { locale: lang });
                    }}
                    style={{
                        textTransform: 'none',
                        backgroundColor: getCustomButton1(business),
                        borderRadius: getCustomRadius(business),
                        color: '#FFFFFF',
                        paddingTop: isMobile ? 6 : 0,
                        paddingBottom: isMobile ? 6 : 0,
                        lineHeight: isMobile ? 1 : 1,
                        margin: 5,
                        fontWeight: '500',
                    }}
                >
                    {' '}
                    <span>
                        {nbTodayTableOrder === 1
                            ? translateMsg('webapp', 'pwa_ui__see_my_order')
                            : `${translateMsg(
                                  'webapp',
                                  'pwa_ui__see_my',
                              )} ${nbTodayTableOrder} ${translateMsg(
                                  'webapp',
                                  'pwa_ui__orders',
                              )}`}
                    </span>
                    {` `} <span style={{ padding: 10 }}>•</span>{' '}
                    <span style={{ marginLeft: 5, color: '#ffffffaa' }}>
                        {translateMsg('webapp', 'pwa_ui__on_the_spot')}
                    </span>
                </Button>
            )}

            {nbTodayTakeawayOrder > 0 &&
                +business.info.headband_takeaway === 1 && (
                    <Button
                        variant="outlined"
                        onClick={(event) => {
                            event.preventDefault();
                            router.push(url1, url1, { locale: lang });
                        }}
                        style={{
                            textTransform: 'none',
                            backgroundColor: getCustomButton1(business),
                            borderRadius: getCustomRadius(business),
                            color: '#FFFFFF',
                            paddingTop: isMobile ? 6 : 0,
                            paddingBottom: isMobile ? 6 : 0,
                            lineHeight: isMobile ? 1 : 1,
                            margin: 5,
                            fontWeight: '500',
                        }}
                    >
                        {' '}
                        <span>
                            {nbTodayTakeawayOrder === 1
                                ? translateMsg('webapp', 'pwa_ui__see_my_order')
                                : `${translateMsg(
                                      'webapp',
                                      'pwa_ui__see_my',
                                  )} ${nbTodayTakeawayOrder} ${translateMsg(
                                      'webapp',
                                      'pwa_ui__orders',
                                  )}`}{' '}
                        </span>
                        {` `} <span style={{ padding: 10 }}>•</span>{' '}
                        <span style={{ marginLeft: 5, color: '#ffffffaa' }}>
                            {translateMsg('webapp', 'pwa_ui__take_away')}
                        </span>
                    </Button>
                )}
        </div>
    );
}

export default App;
